import { render, staticRenderFns } from "./XFormPermalinks.vue?vue&type=template&id=2bd88dd0&"
import script from "./XFormPermalinks.vue?vue&type=script&lang=js&"
export * from "./XFormPermalinks.vue?vue&type=script&lang=js&"
import style0 from "./XFormPermalinks.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports